import { Box, Button, Chip, Stack, Tab, Tabs } from "@mui/material";
import Header from "../Header";
import { DataGrid } from "@mui/x-data-grid";
import { useEffect, useState } from "react";
import baseRequest from "../../core/baseRequest";

import { toStringDate } from "../../utils/helpers";
import { useSnackbar } from "notistack";
import useControl from "../../hooks/useControl";
import useSignOut from "../../hooks/useSignOut";
import { useNavigate } from "react-router-dom";
import { errorHandler } from "../../core/errorHandler";
import { EventRepeat, Hardware } from "@mui/icons-material";

const ApprovePage = () => {
  const { enqueueSnackbar } = useSnackbar();
  const [auth] = useControl();
  const [controller] = useSignOut();
  const navigate = useNavigate();

  const [rows, setRows] = useState([]);
  const [repairRows, setRepairRows] = useState([]);

  const [tabSelector, setTabSelector] = useState(0);

  const [selections, setSelections] = useState([]);
  const [repairSelections, setRepairSelections] = useState([]);

  const repairColumns = [
    {
      field: "createdAt",
      headerName: "Created Time",
      width: 130,
      valueGetter: (value, row) =>
        toStringDate(value.row.createdAt, {
          month: "short",
          year: "numeric",
          day: "numeric",
          hour: "numeric",
          minute: "numeric",
        }),
    },
    { field: "target", headerName: "Target Name", width: 130 },
    { field: "problem", headerName: "Repair Performed", width: 300 },
  ];

  const columns = [
    {
      field: "createdAt",
      headerName: "Created Time",
      width: 130,
      valueGetter: (value, row) =>
        toStringDate(value.row.createdAt, {
          month: "short",
          year: "numeric",
          day: "numeric",
          hour: "numeric",
          minute: "numeric",
        }),
    },
    { field: "target", headerName: "Target Name", width: 130 },
    {
      field: "maintenances",
      headerName: "Maintenances",
      width: 260,
      renderCell: ({ row }) => {
        return (
          <Stack spacing={1}>
            {row.maintenances.map((maintenance) => {
              return <Chip label={maintenance} color="secondary" />;
            })}
          </Stack>
        );
      },
    },
    {
      field: "inspected",
      valueGetter: (value, row) => value.row.inspected.toUpperCase(),
      headerName: "Inspected?",
      width: 120,
    },
    {
      field: "foodSafety",
      valueGetter: (value, row) => value.row.foodSafety.toUpperCase(),
      headerName: "Food Safety?",
      width: 120,
    },
    {
      field: "serviceRequired",
      headerName: "Service Required?",
      valueGetter: (value, row) => value.row.serviceRequired.toUpperCase(),
      width: 120,
    },
  ];

  const loadApprovePage = async () => {
    const result = await baseRequest.get("/approves");
    if (result.data) {
      setRows(result.data?.logs);
    }
  };

  const loadRepairApproves = async () => {
    const result = await baseRequest.get("/approves/repair");
    console.log(result);
    if (result.data) {
      setRepairRows(result.data?.logs);
    }
  };

  useEffect(() => {
    loadApprovePage();
  }, []);

  const handleApproveRepair = async () => {
    try {
      const res = await baseRequest.put("/approves/repair/approve", {
        data: repairSelections,
      });
      if (auth(res)) {
        await loadRepairApproves();
        enqueueSnackbar("Records have been successfully approved!", {
          variant: "success",
        });
      }
    } catch (error) {
      const { data, status } = errorHandler(error);
      switch (status) {
        case 401:
          controller.forceLogin();
          break;
        case 403:
          navigate("/noaccess");
          break;
        case 400:
          enqueueSnackbar("Something went wrong while approval!", {
            variant: "error",
          });
          break;
        case 500:
          enqueueSnackbar(
            "Something went wrong while updating from database!",
            {
              variant: "error",
            }
          );
          break;
        default:
          enqueueSnackbar(data, {
            variant: "error",
          });
          break;
      }
    }
  };
  const handleRejectRepair = async () => {
    try {
      const res = await baseRequest.put("/approves/repair/reject", {
        data: repairSelections,
      });
      if (auth(res)) {
        await loadRepairApproves();
        enqueueSnackbar("Records have been successfully rejected!", {
          variant: "success",
        });
      }
    } catch (error) {
      const { data, status } = errorHandler(error);
      switch (status) {
        case 401:
          controller.forceLogin();
          break;
        case 403:
          navigate("/noaccess");
          break;
        case 400:
          enqueueSnackbar("Something went wrong while rejection!", {
            variant: "error",
          });
          break;
        case 500:
          enqueueSnackbar(
            "Something went wrong while updating from database!",
            {
              variant: "error",
            }
          );
          break;
        default:
          enqueueSnackbar(data, {
            variant: "error",
          });
          break;
      }
    }
  };

  const handleReject = async () => {
    try {
      const res = await baseRequest.put("/approves/reject", {
        data: selections,
      });
      if (auth(res)) {
        await loadApprovePage();
        enqueueSnackbar("Records have been successfully rejected!", {
          variant: "success",
        });
      }
    } catch (error) {
      const { data, status } = errorHandler(error);
      switch (status) {
        case 401:
          controller.forceLogin();
          break;
        case 403:
          navigate("/noaccess");
          break;
        case 400:
          enqueueSnackbar("Something went wrong while rejection!", {
            variant: "error",
          });
          break;
        case 500:
          enqueueSnackbar(
            "Something went wrong while updating from database!",
            {
              variant: "error",
            }
          );
          break;
        default:
          enqueueSnackbar(data, {
            variant: "error",
          });
          break;
      }
    }
  };

  const handleApprove = async () => {
    try {
      const res = await baseRequest.put("/approves/approve", {
        data: selections,
      });
      if (auth(res)) {
        await loadApprovePage();
        enqueueSnackbar("Records have been successfully approved!", {
          variant: "success",
        });
      }
    } catch (error) {
      const { data, status } = errorHandler(error);
      switch (status) {
        case 401:
          controller.forceLogin();
          break;
        case 403:
          navigate("/noaccess");
          break;
        case 400:
          enqueueSnackbar("Something went wrong while approval!", {
            variant: "error",
          });
          break;
        case 500:
          enqueueSnackbar(
            "Something went wrong while updating from database!",
            {
              variant: "error",
            }
          );
          break;
        default:
          enqueueSnackbar(data, {
            variant: "error",
          });
          break;
      }
    }
  };

  return (
    <Box m="0 20px ">
      <Header title="APPROVES" subtitle="Reject or Approve" />

      <Tabs
        value={tabSelector}
        centered
        onChange={async (_, value) => {
          setTabSelector(value);
          if (value === 1) {
            await loadRepairApproves();
          }
        }}
      >
        <Tab
          sx={{ fontSize: 18, fontWeight: "bold" }}
          icon={<EventRepeat sx={{ fontSize: 30 }} />}
          label="Maintenance"
        />
        <Tab
          sx={{ fontSize: 18, fontWeight: "bold" }}
          icon={<Hardware sx={{ fontSize: 30 }} />}
          label="Repair"
        />
      </Tabs>
      <Box sx={{ display: tabSelector === 1 ? "block" : "none" }}>
        <Stack direction="row" spacing={3}>
          <Button
            color="error"
            variant="contained"
            onClick={handleRejectRepair}
          >
            Reject
          </Button>
          <Button
            color="success"
            variant="contained"
            onClick={handleApproveRepair}
          >
            Approve
          </Button>
        </Stack>

        <DataGrid
          getRowId={(row) => {
            return row._id;
          }}
          rows={repairRows}
          columns={repairColumns}
          initialState={{
            pagination: { paginationModel: { page: 0, pageSize: 10 } },
          }}
          pageSizeOptions={[5, 10]}
          checkboxSelection
          onRowSelectionModelChange={(details) => {
            setRepairSelections(details);
          }}
          sx={{ border: 0 }}
        />
      </Box>

      <Box sx={{ display: tabSelector === 0 ? "block" : "none" }}>
        <Stack direction="row" spacing={3}>
          <Button color="error" variant="contained" onClick={handleReject}>
            Reject
          </Button>
          <Button color="success" variant="contained" onClick={handleApprove}>
            Approve
          </Button>
        </Stack>

        <DataGrid
          getRowId={(row) => {
            return row._id;
          }}
          rows={rows}
          columns={columns}
          initialState={{
            pagination: { paginationModel: { page: 0, pageSize: 10 } },
          }}
          pageSizeOptions={[5, 10]}
          checkboxSelection
          onRowSelectionModelChange={(details) => {
            setSelections(details);
          }}
          sx={{ border: 0 }}
        />
      </Box>
    </Box>
  );
};

export default ApprovePage;
